export { default as ImageVoucher } from './image-voucher.svg';
